import { render, staticRenderFns } from "./addAllocate.vue?vue&type=template&id=818c6818&scoped=true"
import script from "./addAllocate.vue?vue&type=script&lang=js"
export * from "./addAllocate.vue?vue&type=script&lang=js"
import style0 from "./addAllocate.vue?vue&type=style&index=0&id=818c6818&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818c6818",
  null
  
)

export default component.exports